import 'css-chunksrc/client/scenes/projectCreationForm/projectPortfoliosList/styles.scss';export default {
  "projectPortfoliosList": "_projectPortfoliosList_m0qrf_1",
  "item": "_item_m0qrf_10",
  "icon": "_icon_m0qrf_14",
  "input": "_input_m0qrf_19",
  "list": "_list_m0qrf_24"
};